import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const estimateService = {
  getEstimates: async () => {
    const response = await api.get('/estimates');
    return response.data;
  },
  getJobEstimates: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}/estimates`);
    return response.data;
  },
  getEstimate: async (id) => {
    const response = await api.get(`/estimates/${id}`);
    return response.data;
  },
  createEstimate: async (data) => {
    const response = await api.post('/estimates', data);
    return response.data;
  },
  updateEstimate: async (id, data) => {
    const response = await api.put(`/estimates/${id}`, data);
    return response.data;
  },
  deleteEstimate: async (id) => {
    const response = await api.delete(`/estimates/${id}`);
    return response.data;
  },
};
